import { createReducer } from 'redux-starter-kit';
import { SET_ASSETS } from './assets.actions';
import { AssetReducerType } from './assets.types';

const initialState: AssetReducerType = {
  list: {
    count: -1,
    next: '',
    previous: '',
    results: [],
  },
};

export default createReducer(initialState, {
  [SET_ASSETS]: (state, action) => {
    state.list = action.payload;
  },
});
